import React from "react";
import DOMPurify from "dompurify";

export default function Card({ title, description, children, html = null }) {
  if ((title && (description || html)) || children) {
    return (
      <>
        <div className="space-y-2 border p-4 rounded-lg shadow-md w-full">
          {title && <span className="block font-bold text-gray-700 text-lg">{title}</span>}

          {html
            ? (
              <div
                className="text-gray-900 description-content"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
              />
            )
            : (
              <p className="text-gray-900">{description}</p>
            )}

          {children}
        </div>
      </>
    );
  }
  return null;
}
